<template>
  <v-sheet>
    <div id="waveTop"></div>
    <v-container class="py-4 py-lg-8 mt-4 mb-12" style="background-color: white;">
      <h2 style="text-align: center; font-size: 40px">
        {{ $t('criptonomia') }}
      </h2>
      <v-row>
        <v-card
          v-for="(item, i) in $t('landing.products')"
          :key="i"
          :class="
            $vuetify.breakpoint.mdAndUp ? 'col-4 aling-center mt-6' : 'col-12 aling-center mt-6'
          "
          max-width="500"
          outlined
          style="margin-left: auto; margin-right: auto; margin-bottom: 10px; text-align: center; border-color: white"
        >
          <v-img
            height="70px"
            width="70px"
            :src="obj[i].img"
            alt=""
            style="margin-left: auto; margin-right: auto;"
          >
          </v-img>
          <h3>{{ item.title }}</h3>
          <p :style="$vuetify.breakpoint.mdAndUp ? 'font-size: 15px' : 'font-size: 18px'">
            {{ item.subtitle }}
          </p>
        </v-card>
      </v-row>
      <p style="text-align: center; font-size: 20px;">
        Nossa especialidade é beneficiar processos corporativos promovendo um novo patamar de
        transparência entre clientes e fornecedores, audibilidade de processos e provas de registro.
      </p>
    </v-container>
    <div id="waveButton"></div>
  </v-sheet>
</template>

<script>
import Produtos from 'Assets/Produtos/produtos.png';
import ImgBlockchain from 'Assets/Landing/blockchain2.png';
import RegistroDeDocumentos from 'Assets/QuemSomos/RegistroDeDocumentos.png';
import TokenizacaoDeAtivos from 'Assets/QuemSomos/TokenizacaoDeAtivos.png';
export default {
  name: 'Specialty',
  data() {
    return {
      Produtos,
      ImgBlockchain,
      obj: [
        {
          img: TokenizacaoDeAtivos,
        },
        {
          img: RegistroDeDocumentos,
        },
      ],
    };
  },
  components: {},
};
</script>
